/** On-screen copy shared with iOS IntraopCopy. Do not invent extra help text. */

export const intraopCopy = {
  phaseTitle: "Count tracker",
  specimenSectionTitle: "Specimen",
  site: "Site",
  laterality: "Laterality",
  defaultListName: "Default",
  listLabel: "List",
  addRow: "+ Add",
  currentlyInBody: "Currently in patient's body",
  out: "OUT",
  inPatient: "IN PATIENT",
  inPatientWire: "IN_PATIENT",
  addList: "+ Add List",
  left: "Left",
  right: "Right",
  na: "N/A",
  addSpecimenToList(listName: string) {
    return `+ Add specimen to ${listName}`;
  },
};

export const lateralityLabel: Record<string, string> = {
  LEFT: intraopCopy.left,
  RIGHT: intraopCopy.right,
  NA: intraopCopy.na,
};

export const countCategories = [
  { wire: "laps", title: "Lap / Sponge" },
  { wire: "gauze", title: "4X4 / Gauze" },
  { wire: "needles", title: "Needles" },
  { wire: "instruments", title: "Instruments" },
] as const;

export function countLabel(title: string) {
  return `Your ${title.toLowerCase()} count before incision`;
}

export function isInPatient(state: string) {
  return state.replaceAll(" ", "_").toUpperCase() === intraopCopy.inPatientWire;
}

export function catalogDisplayName(name: string, isDefault: boolean) {
  const trimmed = name.trim();
  if (trimmed) return trimmed;
  return isDefault ? intraopCopy.defaultListName : intraopCopy.listLabel;
}
